export const DEFAULT_LOCALE = 'en-US';

export const photoAmountLimit = { checkup: 15, damage: 50, issueReport: 50 };
export const photoSizeLimit = 12; // megabytes
export const photoSizeLimitInBytes = photoSizeLimit * 1024 * 1024;
export const photoMaxPixelSize = 2048; // max. width or height in pixels
export const photoImageFormat = 'image/jpeg';


export const photoStepIncrement = 4;

export const toastDismissalTimeout = {
    long: 2500, // ms
    short: 750 // ms
};

export const maxShiftEditingDayDiff = 7;

export const DEBOUNCE_TIME_DATE_PICKER_VALUE = 250;
export const DEBOUNCE_TIME_FREE_TEXT_VALUE = 500;

export const DELIMITER = ';';

